import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { IpPublicService } from 'src/app/services/ip-public.service';
import { ModalService } from './../../../../../services/modal.service';
import { AlertService } from 'src/app/services/alert.service';
import { DataTableDirective } from 'angular-datatables';
import { mergeMap, Subject } from 'rxjs';
import { ObjetivoService } from '../../../services/objetivo.service';
import { EstrategiaObjetivoService } from '../../../services/estrategia-objetivo.service';
import { EstrategiasService } from '../../../services/estrategias.service';
import { LineaAccionService } from '../../../services/linea-accion.service';
import { ProcesoService } from '../../../services/proceso.service';
import { ProyectoService } from '../../../services/proyecto.service';
import { AppState } from 'src/app/app.reducer';
import { Store } from '@ngrx/store';
import { ConstantsCatalogosIdService } from './../../../../../services/constants-catalogos-id.service';

import { Observable } from 'rxjs';
@Component({
  selector: 'app-objetivos-estrategias',
  templateUrl: './objetivos-estrategias.component.html',
  styleUrls: ['./objetivos-estrategias.component.css'],
})
export class ObjetivosEstrategiasComponent implements OnInit, OnDestroy {
  private dataObjetivos: any[];
  public formEstrategias!: UntypedFormGroup;
  //public formSubmitted = false;
  public submitted = false;
  private dataEstrategias: any[];
  private dataEstrategiaObjetivo: any;
  public dataEstrategiasMain: any[];
  public selectItems: any[];
  public nameModal: string = 'Modal-objetivos-estrategias';
  public nameApp: string = 'ESTRATEGIAS DE OBJETIVOS';
  public idSprObjetivoSelected: number = 0;
  public nombreObjetivoSelected: string = '';
  public buffer: string;
  public currentUser: any;
  public idSprAmbiente: number = 0;
  public idSprNivel: number = 0;
  public idDeleteRegister: number = 0;
  public idSprUsuario: number = 0;
  public idSprEstrategiaObjetivo: number = 0;
  private ipAddress: string = '0';
  public idObjetivo: number;
  public objetivoNombre: any;
  public idSprNivelN5: number = 0; //validacion (de nivel n5)

  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject<any>();

  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;

  isDtInitialized: boolean = false;
  @Output('onSaveEstrategia') onSaveEstrategia = new EventEmitter<any>();
  @Input() set msgEstrategia(data: any) {
    this.idObjetivo = data.idSprObjetivo;
    this.objetivoNombre = data.objetivoNombre;
    this.ngOnInit();
  }

  ngOnInit(): void {
    this.store.select('globalApp').subscribe((response) => {
      this.idSprNivel = response.ambienteSeleccionado.nivel.idSprNivel;
    });
    this.getIpPublic();
    this.initApp();
  }

  initApp() {
    this.getDataObjetivo(this.idObjetivo);
    this.setDataTable();
  }
  getIpPublic() {
    this.ip.getIPAddress().subscribe((res: any) => {
      this.ipAddress = res.ip;
    });
  }
  get EstrategiasForm() {
    return this.formEstrategias.controls;
  }
  readonly constant = ConstantsCatalogosIdService;
  constructor(
    private objetivoService: ObjetivoService,
    private estrategiaObjetivoService: EstrategiaObjetivoService,
    private estrategiaService: EstrategiasService,
    public modal: ModalService,
    private estrategiasService: EstrategiasService,
    private lineaAccionService: LineaAccionService,
    private procesoService: ProcesoService,
    private proyectoService: ProyectoService,
    private alert: AlertService,
    private ip: IpPublicService,
    private fb: FormBuilder,
    private store: Store<AppState>
  ) {
    this.getIpPublic();
    this.buffer = localStorage.getItem('currentUser');
    this.currentUser = JSON.parse(this.buffer);
    this.idSprUsuario = this.currentUser.idSprUsuario;
    this.idSprAmbiente = this.currentUser.idSprAmbiente;

   

    this.idSprNivelN5 = ConstantsCatalogosIdService.ID_COMUNES_NIVEL_5;

    this.formEstrategias = this.fb.group({
      idSprEstrategiaObjetivo: ['', []],
      idSprEstrategia: [, []],
      idSprObjetivo: [, []],
      nombre: ['', [Validators.required]],
      estado: [1, [Validators.required]],
      nivelActual: [],
      idSprNivel: [, []],
    });

    this.selectItems = [
      { value: '', label: 'Seleccione' },
      { value: 1, label: 'Activo' },
      { value: 2, label: 'Inactivo' },
    ];
  }

  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    this.dtTrigger.unsubscribe();
  }

  setDataTable() {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      destroy: true,
      language: {
        //url: '//cdn.datatables.net/plug-ins/1.13.4/i18n/es-ES.json',
      },
    };
  }

  reDrawDataTable() {
    // Redibujar la tabla al actualizar datos
    if (this.isDtInitialized) {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.dtTrigger.next(null);
      });
    } else {
      this.isDtInitialized = true;
      this.dtTrigger.next(null);
    }
  }

  async  onSubmit(): Promise<boolean> {
    this.formEstrategias.value.usuario = this.currentUser.idSprUsuario;
    this.formEstrategias.value.ip = this.ipAddress;
    this.formEstrategias.value.idSprObjetivo = this.idObjetivo;
    this.formEstrategias.value.idSprAmbiente = this.currentUser.idSprAmbiente;
    this.formEstrategias.value.idSprNivel = this.currentUser.idSprNivel;

    this.submitted = true;

    if (this.formEstrategias.valid) {
      if (
        this.formEstrategias.value.idSprEstrategia == null ||
        this.formEstrategias.value.idSprEstrategia == ''
      ) {

        const existe = await this.verificarNombre(
          this.formEstrategias.value.nombre,
          this.formEstrategias.value.idSprNivel,
          this.formEstrategias.value.idSprAmbiente
        );
        if (
          existe
          )
        {
  
          this.formEstrategias.value.delLog = 'N';
          let estrategia = {
            nombre: this.formEstrategias.value.nombre,
            estado: this.formEstrategias.value.estado,
            ip: this.ipAddress,
            usuario: this.currentUser.idSprUsuario,
            idSprNivel: this.formEstrategias.value.idSprNivel,
            idSprAmbiente: this.formEstrategias.value.idSprAmbiente,
          };
          let idSprEstrategiaUltimo: any;
          this.estrategiasService
            .create(estrategia)
            .pipe(
              mergeMap((estrategiaGuardada) => {
                idSprEstrategiaUltimo = estrategiaGuardada.idSprEstrategia;
                this.formEstrategias.value.nivelSuperior = 'N';
                this.formEstrategias.value.idSprEstrategia =
                  estrategiaGuardada.idSprEstrategia;
                return this.estrategiaObjetivoService.create(
                  this.formEstrategias.value
                );
              })
            )
            .subscribe({
              next: (data) => {
                this.getDataObjetivo(this.idObjetivo);
                this.alert.createOk();
                this.onSaveEstrategia.emit();
                this.closeModalEstrategias();
              },
              error: (err) => {
                this.alert.createError();
                let estrategiaObjetivo = {
                  idSprEstrategia: idSprEstrategiaUltimo,
                  delLog: 'S',
                };
                this.estrategiasService.update(estrategiaObjetivo).subscribe();

                //this.modal.close();
              },
            });
        } else{
          this.alert.warning(
            '¡Atención!',
            'Existe una estrategia con el mismo nombre.'
          );
        }
        //fin
      } else {

        const existe = await this.verificarNombreEditar(
          this.formEstrategias.value.nombre,
          this.formEstrategias.value.idSprNivel,
          this.formEstrategias.value.idSprAmbiente,
          this.formEstrategias.value.idSprEstrategia,
        );
        if (
          existe
          )
        {
        this.formEstrategias.value.idSprEstrategia;
        this.formEstrategias.value.nombre;
        this.formEstrategias.value.estado;
        this.formEstrategias.value.ip = this.ipAddress;
        (this.formEstrategias.value.usuario = this.currentUser.idSprUsuario),
          
        this.estrategiasService.update(this.formEstrategias.value).subscribe(
          (resp) => {
            this.getDataObjetivo(this.idObjetivo);
            this.closeModalEstrategias();
            this.alert.updateOk();
          },
          (err) => {
            this.alert.updateError();
          }
        );
        //
      }else{
        this.alert.warning(
          '¡Atención!',
          'Existe una estrategia con el mismo nombre.'
        );
      }
    }
      return false;
    } else {
      return false;
    }
  }

  async  verificarNombre(
    nombre: string,
    nivel: number,
    ambiente: number
  ): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      try {
        let existeNombre = false;
        this.estrategiaService
          .list(`?idSprAmbiente=${ambiente}&idSprNivel=${nivel}`)
          .subscribe((dataEstrategias: any[]) => {
            if (dataEstrategias.length === 0) {
              existeNombre = true;
            } else {
              let nombresInicio = nombre.trimStart().trimEnd();
              let nombresFin = nombresInicio.trimEnd();
              for (let elemento of dataEstrategias) {
               if (elemento.nombre === nombresFin) {
      
                  existeNombre = false;
                  break;
                } else{
                  existeNombre = true;
                }
              }
            }
            resolve(existeNombre);
          });
      } catch (error) {
        console.error('Error al verificar nombre:', error);
        reject(false); // Rechaza la promesa en caso de error
      }
    });
  }

  async  verificarNombreEditar(
    nombre: string,
    nivel: number,
    ambiente: number,
    idSprEstrategia: number
  ): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      try {
        let existeNombre = false;
        this.estrategiaService
          .list(`?idSprAmbiente=${ambiente}&idSprNivel=${nivel}`)
          .subscribe((dataEstrategias: any[]) => {
            if (dataEstrategias.length === 0) {
              existeNombre = true;
            } else {
              let vector: any = [];
              let vectorFiltrado: any = [];
              let nombresInicio = nombre.trimStart().trimEnd();
              let nombresFin = nombresInicio.trimEnd();
              vector = dataEstrategias;

              for (let elemento of vector) {
                if (elemento.idSprEstrategia !== idSprEstrategia) {
                  vectorFiltrado.push(elemento);
          
                  //return false;
                }
              }

              for (let elemento of vectorFiltrado) {
               if (elemento.nombre === nombresFin) {
      
                  existeNombre = false;
                  break;
                } else{
                  existeNombre = true;
                }
              }
            }
            resolve(existeNombre);
          });
      } catch (error) {
        console.error('Error al verificar nombre:', error);
        reject(false); // Rechaza la promesa en caso de error
      }
    });
  }
  getDataObjetivo(idSprObjetivo: number) {
    if (idSprObjetivo) {
      this.objetivoService.list(`${idSprObjetivo}` )
        .subscribe((respuestaService) => {
          this.dataObjetivos = [respuestaService];
          this.getDataEstrategiaObjetivo();
        });
    }
  }
  getDataEstrategiaObjetivo() {
    this.estrategiaObjetivoService
      .list('?nivelSuperior=N')
      .subscribe((resp) => {
        this.dataEstrategiaObjetivo = resp;
        this.listEstrategia();
      });
  }

  listEstrategia() {
    this.estrategiaService.list().subscribe((resp) => {
      this.dataEstrategias = resp;
      this.mapeoEstrategiaObjetivo();
    });
  }

  mapeoEstrategiaObjetivo() {
    let dataProcess: any = [];

    for (let i = 0; i < this.dataObjetivos.length; i++) {
      for (let j = 0; j < this.dataEstrategiaObjetivo.length; j++) {
        if (
          this.dataObjetivos[i].idSprObjetivo ==
          this.dataEstrategiaObjetivo[j].idSprObjetivo
        ) {
          for (let k = 0; k < this.dataEstrategias.length; k++) {
            if (
              this.dataEstrategias[k].idSprEstrategia ==
              this.dataEstrategiaObjetivo[j].idSprEstrategia
            ) {
              dataProcess.push({
                idSprEstrategia: this.dataEstrategias[k].idSprEstrategia,
                idSprObjetivo: this.dataObjetivos[i].idSprObjetivo,
                idSprEstrategiaObjetivo:
                  this.dataEstrategiaObjetivo[j].idSprEstrategiaObjetivo,
                objetivo: this.dataObjetivos[i].nombre,
                estrategia: this.dataEstrategias[k].nombre,
                estado: this.dataEstrategias[k].estado,
              });
            }
          }
        }
      }
      this.dataEstrategiasMain = dataProcess;
    }

    this.reDrawDataTable();
  }

  openModal() {
    this.onResetForm();
    this.modal.open(this.nameModal);
  }

  edit(row: any) {
    this.modal.open(this.nameModal);
    this.formEstrategias.patchValue({
      idSprEstrategia: row.idSprEstrategia,
      idSprEstrategiaObjetivo: row.idSprEstrategiaObjetivo,
      nombre: row.estrategia,
      estado: row.estado,
    });
  }
  delete(row: any) {
    this.idDeleteRegister = row.idSprEstrategia;
    this.idSprEstrategiaObjetivo = row.idSprEstrategiaObjetivo;
    this.modal.open('delete-estrategia');
  }

  verifyLineaAccion() {
    return this.lineaAccionService
      .list(`?idSprEstrategia=${this.idDeleteRegister}&delLog=N`)
      .toPromise();
  }

  verifyPoyecto() {
    return this.proyectoService
      .list(`?idSprEstrategia=${this.idDeleteRegister}&delLog=N`)
      .toPromise();
  }

  verifyPoceso() {
    return this.procesoService
      .list(`?idSprEstrategia=${this.idDeleteRegister}&delLog=N`)
      .toPromise();
  }

  async confirmDelete() {
    let confirmDelete = true;
    let dataVerifyRelacion: any = [];
    //verificacion1 si existe datos relacionado
    dataVerifyRelacion = await this.verifyLineaAccion();
    dataVerifyRelacion.length > 0 ? (confirmDelete = false) : '';

    //verificacion2 si existe datos relacionado
    dataVerifyRelacion = await this.verifyPoyecto();
    dataVerifyRelacion.length > 0 ? (confirmDelete = false) : '';

    // verificacion2 si existe datos relacionado
    dataVerifyRelacion = await this.verifyPoceso();
    dataVerifyRelacion.length > 0 ? (confirmDelete = false) : '';

    if (confirmDelete) {
      this.estrategiaService
        .update({
          idSprEstrategia: this.idDeleteRegister,
          usuario: this.currentUser.idSprUsuario,
          delLog: 'S',
          ip: this.ipAddress,
        })
        .subscribe(
          (resp) => {
            let data = {
              idSprEstrategiaObjetivo: this.idSprEstrategiaObjetivo,
              delLog: 'S',
              usuario: this.currentUser.idSprUsuario,
              ip: this.ipAddress,
            };
            return this.estrategiaObjetivoService
              .update(data)
              .subscribe((resp) => {
                this.getDataObjetivo(this.idObjetivo);
                this.alert.deleteOk();
                this.onSaveEstrategia.emit();
                this.modal.closeId('delete-estrategia');
              });
          },
          (err) => {
            this.alert.deleteError();
            this.modal.close();
          }
        );
    } else {
      this.alert.EliminarRegistro();
      this.modal.closeId('delete-estrategia');
    }
  }

  mostrarDetalle(row: any) {}

  closeModalEstrategias() {
    this.modal.closeId(this.nameModal);
  }
  onResetForm() {
    this.submitted = false;
    this.formEstrategias.reset();
    this.formEstrategias.patchValue({
      ...this.formEstrategias.value,
      estado: 1,
    });
  }
}
